import { FlexGrow, Flex, FormConfigurationProvider } from '@equifinance/shared';
import styled from 'styled-components';
import { ToggleButtons } from '../../Buttons/ToggleButton';

const Container = styled(Flex)`${({ theme }) => `
  width: 100%;
  align-items: center;
  padding-block: ${theme.padding[5]};
`}`;

type TaskToggleButtonsProps = {
  onExpandAll(): void;
  onCollapseAll(): void;
}

function TaskToggleButtons({ onExpandAll, onCollapseAll }: TaskToggleButtonsProps) {
  return (
    <FormConfigurationProvider isReadOnlyInput={false}>
      <Container>
        <FlexGrow />
        <ToggleButtons onExpandAll={onExpandAll} onCollapseAll={onCollapseAll} />
      </Container>
    </FormConfigurationProvider>
  );
}

export default TaskToggleButtons;
